import _Row from './Row';
import _Col from './Col';

import './style/index.js';

export type { RowProps } from './Row';
export type { ColProps } from './Col';
export * from './type';

export const Row = _Row;
export const Col = _Col;
